import { FcGoogle } from 'react-icons/fc';
import { Button, Card, Form, Input } from 'antd';

import Logo from "../../components/Logo.jsx";

export const AuthLogo = () => (
  <div style={{ margin: 50 }}>
    <h3
      style={{
        marginTop: 20,
        textDecorationLine: 'underline',
        marginBottom: 20,
        fontWeight: 800,
        fontStyle: 'italic',
        fontFamily: 'Plus Jakarta Sans',
        fontSize: 32,
        color: 'black',
        textAlign: 'center',
      }}
    >
      <Logo width={40} height={40} />
    </h3>
  </div>
);

export const AuthPage = ({ children }) => (
  <div style={{ width: '100vw', height: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
    <Card
      style={{
        width: '100%',
        margin: 'auto',
        maxWidth: 400,
        padding: 20,
      }}
    >
      <div>{children}</div>
    </Card>
  </div>
);

export const AuthDivider = () => (
  <div style={{ display: 'flex', gap: 12, alignItems: 'center', margin: '20px 0' }}>
    <div style={{ width: '100%', height: 1, backgroundColor: 'lightgray' }} />
    <span>or</span>
    <div style={{ width: '100%', height: 1, backgroundColor: 'lightgray' }} />
  </div>
);

export const GoogleButton = ({ onClick, text = 'Continue with Google', loading, disabled }) => (
  <Button onClick={onClick} style={{ width: '100%' }} loading={loading} disabled={disabled}>
    <FcGoogle style={{ fontSize: 18 }} />
    <div>{text}</div>
  </Button>
);

export const EmailForm = ({ isLogin = true, loading, disabled }) => (
  <div style={{ display: 'flex', flexDirection: 'column' }}>
    <Form.Item
      label="Email address"
      name="email"
      rules={[
        {
          required: true,
          message: 'Please input your email',
        },
        {
          type: 'email',
          message: 'Please enter a valid email address',
        },
      ]}
    >
      <Input />
    </Form.Item>
    <Form.Item
      label="Password"
      name="password"
      rules={[
        {
          required: true,
          message: 'Please input your password',
        },
        {
          min: 8,
          message: 'Password must be at least 8 characters',
        },
      ]}
    >
      <Input.Password />
    </Form.Item>
    <Form.Item>
      <Button htmlType="submit" style={{ width: '100%' }} loading={loading} disabled={disabled}>
        {isLogin ? 'Login' : 'Register'}
      </Button>
    </Form.Item>
  </div>
);
